module.exports = __webpack_public_path__ + "img/search_bg.a8254383.png";